import { FC } from 'react';
import { PageViewportLayout } from '../template';
import { ErrorPage, ErrorPageButtons } from 'shared/pages/error/ErrorPage';

export const ChunkLoadError: FC = () => {
  return (
    <PageViewportLayout offsetTop={40} justify={'center'} align={'center'}>
        <ErrorPage
          title='При загрузке произошла ошибка'
          text='Попробуйте обновить страницу'
          buttons={ErrorPageButtons.REFRESH}
          noTheme
        />
    </PageViewportLayout>
  );
};
import { FC } from 'react';
import { PageViewportLayout } from '../template';
import { ErrorPage, ErrorPageButtons } from 'shared/pages/error/ErrorPage';

export const ChunkLoadError: FC = () => {
  return (
    <PageViewportLayout offsetTop={40} justify={'center'} align={'center'}>
        <ErrorPage
          title='При загрузке произошла ошибка'
          text='Попробуйте обновить страницу'
          buttons={ErrorPageButtons.REFRESH}
          noTheme
        />
    </PageViewportLayout>
  );
};
